import React from "react";
import "../pages/style.css";

const PrivacyPolicy = () => (
  <div className="privacy-policy-container px-6 py-8 max-w-3xl mx-auto text-gray-800">
    <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
    <p className="mb-2 font-semibold">GLOBAL STUDYIN</p>
    <p className="mb-4 text-sm text-gray-500">Last updated: 20th December 2025</p>
    <p className="mb-4">GLOBAL STUDYIN (“we”, “us”, “our”) is committed to protecting your privacy and personal data. This Privacy Policy explains how we collect, use, store, and protect personal information when you use our website, services, or make payments through our platform.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">1. Who We Are</h2>
    <p className="mb-4">GLOBAL STUDYIN is based in the United Kingdom and provides student counselling, education-related services, and information globally. We act as a Data Controller for the purposes of applicable data protection laws.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">2. Information We Collect</h2>
    <p className="mb-2">We may collect the following types of personal data:</p>
    <ul className="list-disc ml-6 mb-4">
      <li>Identity & Contact Data: Name, email address, phone number, nationality</li>
      <li>Education & Preference Data: Study interests, academic background, counselling preferences</li>
      <li>Payment Data: Transaction details (amount, currency, payment status)</li>
      <li>Technical Data: IP address, browser type, device information, cookies</li>
      <li>Communication Data: Enquiries, form submissions, consent records</li>
    </ul>
    <p className="mb-4">We do not store full credit/debit card details on our servers.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">3. How We Use Your Data</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>Provide student counselling and education-related services</li>
      <li>Communicate relevant resources, updates, and events (with consent)</li>
      <li>Process payments and manage transactions</li>
      <li>Improve our website, services, and user experience</li>
      <li>Meet legal, regulatory, and compliance obligations</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">4. Legal Basis for Processing (GDPR)</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>Consent – where you have explicitly agreed</li>
      <li>Contractual necessity – to provide requested services</li>
      <li>Legal obligation – compliance with Global or international laws</li>
      <li>Legitimate interests – improving services and ensuring security</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">5. Financial Payments</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>Payments made through GLOBAL STUDYIN are processed securely using trusted third-party payment processors compliant with industry security standards (e.g., PCI-DSS).</li>
      <li>Payment providers may collect and process data directly in accordance with their own privacy policies</li>
      <li>GLOBAL STUDYIN only retains limited transaction records necessary for accounting, legal, and support purposes</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">6. International Data Transfers</h2>
    <p className="mb-4">As we operate globally, your data may be transferred to and processed outside the Global or EEA. Where this occurs, we ensure appropriate safeguards are in place, including:</p>
    <ul className="list-disc ml-6 mb-4">
      <li>Global GDPR-approved transfer mechanisms</li>
      <li>Standard Contractual Clauses (SCCs) or equivalent protections</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">7. Data Retention</h2>
    <p className="mb-4">We retain personal data only for as long as necessary to fulfil the purposes outlined in this policy, comply with legal obligations, or resolve disputes.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">8. Your Data Protection Rights</h2>
    <p className="mb-2">Under GDPR and applicable laws, you have the right to:</p>
    <ul className="list-disc ml-6 mb-4">
      <li>Access your personal data</li>
      <li>Request correction or deletion</li>
      <li>Restrict or object to processing</li>
      <li>Withdraw consent at any time</li>
      <li>Request data portability</li>
      <li>Lodge a complaint with the Global Information Commissioner’s Office (ICO)</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">9. Cookies</h2>
    <p className="mb-4">We use cookies and similar technologies to enhance website functionality and analytics. You can manage or disable cookies through your browser settings.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">10. Data Security</h2>
    <p className="mb-4">We implement appropriate technical and organisational measures to protect personal data against unauthorised access, loss, or misuse.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">11. Third-Party Links</h2>
    <p className="mb-4">Our website may contain links to third-party websites. We are not responsible for their privacy practices or content.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">12. Changes to This Policy</h2>
    <p className="mb-4">We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">13. Contact Us</h2>
    <p className="mb-2">If you have any questions about this Privacy Policy or how we handle your data, please contact:</p>
    <p className="mb-2">GLOBAL STUDYIN</p>
    <p className="mb-2">📞 Call me: +44 20 7277 6666</p>
    <p className="mb-2">📧 Email: <a href="mailto:info@globalstudyin.com" className="text-blue-600 underline hover:text-blue-800 transition-colors duration-200">
      info@globalstudyin.com
    </a></p>
    <p className="mb-2">📍 17 Hanover Square, London W1S 1BN</p>
  </div>
);

export default PrivacyPolicy;
